import { Routes } from '@angular/router';

export const SchemesRoutes: Routes = [

    {
        path: '',
        loadComponent: () => import('./schemes.page').then(m => m.SchemesPage)
    },
    {
        path: 'agri-news',
        loadComponent: () => import('../settings/pages/agri-news/agri-news.page').then(m => m.AgriNewsPage)
    },
    {
        path: 'benefit-registration',
        loadComponent: () => import('./benifit-registration/benifit-registration.page').then(m => m.BenifitRegistrationPage)
    },
    {
        path: 'benefit-otp',
        loadComponent: () => import('./benifit-registration/benegit-otp/benegit-otp.page').then(m => m.BenegitOtpPage)
    },
    {
        path: 'seed-farm',
        loadComponent: () => import('./seed-farm/seed-farm.page').then(m => m.SeedFarmPage)
    },
    {
        path: 'farm-award',
        loadComponent: () => import('./farm-award/farm-award.page').then(m => m.FarmAwardPage)
    },
    {
        path: 'tree-sapling',
        loadComponent: () => import('./tree-sapling/tree-sapling.page').then(m => m.TreeSaplingPage)
    },
    {
        path: 'subsidy-scheme',
        loadComponent: () => import('./subsidy-scheme/subsidy-scheme.page').then(m => m.SubsidySchemePage)
    },
    {
        path: 'elite',
        loadComponent: () => import('./SoilSampleReg/elite-reg.page').then(m => m.EliteRegPage)
    },
    {
        path: 'labour-app',
        loadComponent: () => import('./labour-app/labour-app.page').then(m => m.LabourAppPage)
    },
    {
        path: 'looking-for-workers',
        loadComponent: () => import('./labour-app/looking-for-workers/looking-for-workers.page').then(m => m.LookingForWorkersPage)
    },
    {
        path: 'verify-personal-details',
        loadComponent: () => import('./labour-app/verify-personal-details/verify-personal-details.page').then(m => m.VerifyPersonalDetailsPage)
    },
    {
        path: 'labour-app-registration',
        loadComponent: () => import('./labour-app/labour-app-registration/labour-app-registration.page').then(m => m.LabourAppRegistrationPage)
    },
    {
        path: 'palm-tree',
        loadComponent: () => import('./palm-tree/palm-tree.page').then(m => m.PalmTreePage)
    },
    {
        path: 'agri-entrepreneurshi-scheme',
        loadComponent: () => import('./agri-entrepreneurshi-scheme/agri-entrepreneurshi-scheme.page').then(m => m.AgriEntrepreneurshiSchemePage)
    },
    {
        path: 'kuruvai-package-scheme',
        loadComponent: () => import('./kuruvai-package-scheme/kuruvai-package-scheme.page').then(m => m.KuruvaiPackageSchemePage)
    },
]